/* LXRYWOOD – Raumteiler-Konfigurator 3D (Test-Section, sections/product-raumteiler-konfigurator-3d.liquid).
 *
 * WIEDERVERWENDUNG STATT DUPLIKAT: assets/raumteiler-konfigurator.js bleibt UNVERAENDERT und wird
 * zusaetzlich geladen. Es verwaltet weiterhin komplett: Oberflaeche/Struktur/Breite/Hoehe-State,
 * Preis/Varianten-Aufloesung, Warenkorb, Montage-Check-Dialog. Diese Datei kopiert das NICHT,
 * sondern liest den von Rt bereits geschriebenen DOM-Zustand (data-rt-select/-range, [data-rt-hoehe],
 * [data-rt-txt]) und das `variant:change`-Event, das Rt bei jeder Aenderung auf dem Root feuert.
 * Neu ist ausschliesslich: der three.js-Viewer, sowie die Bedienung fuer die neuen Bloecke
 * Montageart/Regal/Befestigung-Wand (die es im Original nicht gibt).
 *
 * Kein CDN-Import: three.js r128 liegt als lokales Asset (assets/three-r128.min.js, klassisches
 * <script defer>, definiert global `window.THREE`) direkt vor dieser Datei im Template.
 * lessons-learned.md §9: dynamische CDN-Imports werden von der Shopify-Theme-Editor-CSP geblockt.
 *
 * PROGRAMM-JSON zwischen den Markern ist 1:1 aus konfigurator.html kopiert (Repo M-belbau_LXR,
 * Branch claude/zip-extract-delete-3m7wj4, Commit 2e34d4d, erzeugt von cad/rt_web.py -- NICHT von
 * Hand aendern). Bei jeder rt_params.py-Aenderung im Quell-Repo: Block hier neu synchronisieren.
 *
 * Stand 13.10.2026: Profil 28 x 80 mm, Fuge 52 mm (B = 80n - 52), Dachschraege (nur Boden + Decke,
 * reine Vorschau ohne Fertigungsfreigabe, BLOCKER-RT-22). Die Variantenwerte der Breite werden ueber
 * n (Rasterzellen) aufgeloest, nicht ueber den mm-Wert: so funktioniert die Schicht mit den alten
 * (510 ... 2990) wie mit den neuen (508 ... 2988) Shopify-Varianten, ohne Naeherung.
 */
(function () {
  'use strict';
  var Q = function (r, s) { return r.querySelector(s); };
  var QA = function (r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); };

  /* RT-DATEN-ANFANG - erzeugt von cad/rt_web.py, nicht von Hand aendern */
  var PROGRAMM = {"zeichnung":"RT-99-3000","revision":"E","hinweis":"Erzeugt von cad/rt_web.py - nicht von Hand aendern.","profil":{"lamelle_b":28.0,"lamelle_t":80.0,"fuge":52.0,"raster":80.0,"leiste_h":30.0,"leiste_t":80.0,"pfosten_b":28.0,"pfosten_t":80.0},"formel":"B = n x 28 + (n-1) x 52 = 80n - 52","breiten":[{"n":7,"breite":508,"lamellen":5,"pfosten":2,"leiste":452,"elemente":1},{"n":8,"breite":588,"lamellen":6,"pfosten":2,"leiste":532,"elemente":1},{"n":9,"breite":668,"lamellen":7,"pfosten":2,"leiste":612,"elemente":1},{"n":10,"breite":748,"lamellen":8,"pfosten":2,"leiste":692,"elemente":1},{"n":11,"breite":828,"lamellen":9,"pfosten":2,"leiste":772,"elemente":1},{"n":12,"breite":908,"lamellen":10,"pfosten":2,"leiste":852,"elemente":1},{"n":13,"breite":988,"lamellen":11,"pfosten":2,"leiste":932,"elemente":1},{"n":14,"breite":1068,"lamellen":12,"pfosten":2,"leiste":1012,"elemente":1},{"n":15,"breite":1148,"lamellen":13,"pfosten":2,"leiste":1092,"elemente":1},{"n":16,"breite":1228,"lamellen":14,"pfosten":2,"leiste":1172,"elemente":1},{"n":17,"breite":1308,"lamellen":15,"pfosten":2,"leiste":1252,"elemente":1},{"n":18,"breite":1388,"lamellen":16,"pfosten":2,"leiste":1332,"elemente":1},{"n":19,"breite":1468,"lamellen":17,"pfosten":2,"leiste":1412,"elemente":1},{"n":20,"breite":1548,"lamellen":18,"pfosten":2,"leiste":1492,"elemente":1},{"n":21,"breite":1628,"lamellen":19,"pfosten":2,"leiste":1572,"elemente":1},{"n":22,"breite":1708,"lamellen":20,"pfosten":2,"leiste":1652,"elemente":1},{"n":23,"breite":1788,"lamellen":21,"pfosten":2,"leiste":1732,"elemente":1},{"n":24,"breite":1868,"lamellen":22,"pfosten":2,"leiste":1812,"elemente":1},{"n":25,"breite":1948,"lamellen":23,"pfosten":2,"leiste":1892,"elemente":1},{"n":26,"breite":2028,"lamellen":24,"pfosten":2,"leiste":1972,"elemente":1},{"n":27,"breite":2108,"lamellen":25,"pfosten":2,"leiste":2052,"elemente":1},{"n":28,"breite":2188,"lamellen":26,"pfosten":2,"leiste":2132,"elemente":1},{"n":29,"breite":2268,"lamellen":27,"pfosten":2,"leiste":2212,"elemente":1},{"n":30,"breite":2348,"lamellen":28,"pfosten":2,"leiste":2292,"elemente":1},{"n":31,"breite":2428,"lamellen":29,"pfosten":2,"leiste":1226,"elemente":2},{"n":32,"breite":2508,"lamellen":30,"pfosten":2,"leiste":1226,"elemente":2},{"n":33,"breite":2588,"lamellen":31,"pfosten":2,"leiste":1306,"elemente":2},{"n":34,"breite":2668,"lamellen":32,"pfosten":2,"leiste":1306,"elemente":2},{"n":35,"breite":2748,"lamellen":33,"pfosten":2,"leiste":1386,"elemente":2},{"n":36,"breite":2828,"lamellen":34,"pfosten":2,"leiste":1386,"elemente":2},{"n":37,"breite":2908,"lamellen":35,"pfosten":2,"leiste":1466,"elemente":2},{"n":38,"breite":2988,"lamellen":36,"pfosten":2,"leiste":1466,"elemente":2}],"hoehen":[1000,1500,2000,2200,2500,2700,3000],"hoehe_standard":3000,"masse_kg":{"1000":{"508":12.0,"588":13.8,"668":15.5,"748":17.3,"828":19.0,"908":20.7,"988":22.5,"1068":24.2,"1148":26.0,"1228":27.7,"1308":29.5,"1388":31.2,"1468":32.9,"1548":34.7,"1628":36.4,"1708":38.2,"1788":39.9,"1868":41.7,"1948":43.4,"2028":45.1,"2108":46.9,"2188":48.6,"2268":50.4,"2348":52.1,"2428":53.8,"2508":55.6,"2588":57.3,"2668":59.1,"2748":60.8,"2828":62.6,"2908":64.3,"2988":66.0},"1500":{"508":17.5,"588":20.0,"668":22.6,"748":25.1,"828":27.6,"908":30.1,"988":32.7,"1068":35.2,"1148":37.7,"1228":40.3,"1308":42.8,"1388":45.3,"1468":47.8,"1548":50.4,"1628":52.9,"1708":55.4,"1788":57.9,"1868":60.5,"1948":63.0,"2028":65.5,"2108":68.0,"2188":70.6,"2268":73.1,"2348":75.6,"2428":78.2,"2508":80.7,"2588":83.2,"2668":85.7,"2748":88.3,"2828":90.8,"2908":93.3,"2988":95.8},"2000":{"508":23.0,"588":26.3,"668":29.6,"748":32.9,"828":36.2,"908":39.6,"988":42.9,"1068":46.2,"1148":49.5,"1228":52.8,"1308":56.1,"1388":59.4,"1468":62.7,"1548":66.0,"1628":69.4,"1708":72.7,"1788":76.0,"1868":79.3,"1948":82.6,"2028":85.9,"2108":89.2,"2188":92.5,"2268":95.8,"2348":99.1,"2428":102.5,"2508":105.8,"2588":109.1,"2668":112.4,"2748":115.7,"2828":119.0,"2908":122.3,"2988":125.6},"2200":{"508":25.2,"588":28.8,"668":32.4,"748":36.1,"828":39.7,"908":43.3,"988":46.9,"1068":50.6,"1148":54.2,"1228":57.8,"1308":61.4,"1388":65.1,"1468":68.7,"1548":72.3,"1628":75.9,"1708":79.6,"1788":83.2,"1868":86.8,"1948":90.4,"2028":94.1,"2108":97.7,"2188":101.3,"2268":104.9,"2348":108.6,"2428":112.2,"2508":115.8,"2588":119.4,"2668":123.1,"2748":126.7,"2828":130.3,"2908":133.9,"2988":137.5},"2500":{"508":28.5,"588":32.6,"668":36.7,"748":40.8,"828":44.9,"908":49.0,"988":53.1,"1068":57.2,"1148":61.2,"1228":65.3,"1308":69.4,"1388":73.5,"1468":77.6,"1548":81.7,"1628":85.8,"1708":89.9,"1788":94.0,"1868":98.1,"1948":102.2,"2028":106.3,"2108":110.4,"2188":114.5,"2268":118.6,"2348":122.7,"2428":126.8,"2508":130.9,"2588":135.0,"2668":139.0,"2748":143.1,"2828":147.2,"2908":151.3,"2988":155.4},"2700":{"508":30.7,"588":35.1,"668":39.5,"748":43.9,"828":48.3,"908":52.7,"988":57.1,"1068":61.5,"1148":66.0,"1228":70.4,"1308":74.8,"1388":79.2,"1468":83.6,"1548":88.0,"1628":92.4,"1708":96.8,"1788":101.2,"1868":105.6,"1948":110.0,"2028":114.4,"2108":118.8,"2188":123.3,"2268":127.7,"2348":132.1,"2428":136.5,"2508":140.9,"2588":145.3,"2668":149.7,"2748":154.1,"2828":158.5,"2908":162.9,"2988":167.3},"3000":{"508":34.0,"588":38.9,"668":43.7,"748":48.6,"828":53.5,"908":58.4,"988":63.2,"1068":68.1,"1148":73.0,"1228":77.9,"1308":82.8,"1388":87.6,"1468":92.5,"1548":97.4,"1628":102.3,"1708":107.2,"1788":112.0,"1868":116.9,"1948":121.8,"2028":126.7,"2108":131.6,"2188":136.4,"2268":141.3,"2348":146.2,"2428":151.1,"2508":155.9,"2588":160.8,"2668":165.7,"2748":170.6,"2828":175.5,"2908":180.3,"2988":185.2}},"oberflaechen":[{"kuerzel":"EI-NAT","name":"Eiche natur geoelt","behandlung":"geoelt"}],"struktur":"gebuerstet","werkstoff":"Eiche massiv","regal":{"hinweis":"BLOCKER-RT-20 offen: Tragfaehigkeit der gesteckten Duebelverbindung unter Kippmoment nicht nachgerechnet - reine Vorschau, nicht bestellbar.","tiefe":230.0,"ueberstand":75.0,"board_t":30.0,"rand_leiste":300.0,"rand_boden":80.0,"k_optionen":[{"k":3,"aussen":188,"klar":132},{"k":4,"aussen":268,"klar":212}]}};
  /* RT-DATEN-ENDE */

  /* Breite -> Rasterzellen n -> Eintrag. Exakt, kein Naechster-Nachbar: n = (B + Fuge) / Raster.
     Alt (Fuge 50): B = 80n - 50, neu (Fuge 52): B = 80n - 52. (B + 51) / 80 liegt bei beiden
     Staenden knapp neben n und rundet auf n. Unbekannte Werte liefern null (kein stiller Fallback). */
  function eintragFuerBreite(mm) {
    var n = Math.round((mm + 51) / PROGRAMM.profil.raster);
    for (var i = 0; i < PROGRAMM.breiten.length; i++) { if (PROGRAMM.breiten[i].n === n) return PROGRAMM.breiten[i]; }
    return null;
  }

  /* ------------------------------------------------------------------ *
   * Dachschraege (Quelle: konfigurator.html, 28.09.2026, BLOCKER-RT-22). EINE durchgehende
   * Schraege, keine Kehle/kein Knick: mehr Punkte bei groesserer Breite dienen einer
   * zuverlaessigeren Ausgleichsgeraden (kleinste Quadrate), nicht mehreren Winkeln.
   * x = 0 ist der linke Aussenrand. Boden und untere Leiste bleiben waagerecht.
   * ------------------------------------------------------------------ */
  var SCHRAEGE_PUNKTE_SCHWELLE = 1500; /* ab dieser Breite 4 statt 3 Messpunkte */
  var SCHRAEGE_MIN = 1005, SCHRAEGE_MAX = 3000; /* mm, wie Stichmass in der Quelle */
  function schraegePunkteAnzahl(breiteMM) { return breiteMM >= SCHRAEGE_PUNKTE_SCHWELLE ? 4 : 3; }
  function schraegeFit(breiteMM, hs) {
    var n = hs.length, i, xs = [], xBar = 0, hBar = 0, num = 0, den = 0;
    for (i = 0; i < n; i++) { xs.push(i * breiteMM / (n - 1)); xBar += xs[i]; hBar += hs[i]; }
    xBar /= n; hBar /= n;
    for (i = 0; i < n; i++) { num += (xs[i] - xBar) * (hs[i] - hBar); den += Math.pow(xs[i] - xBar, 2); }
    var m = den === 0 ? 0 : num / den;
    return { m: m, b: hBar - m * xBar };
  }
  /* Deckenhoehe an Stelle x (mm, zentriert: 0 = Mitte des Teilers) */
  function schraegeHoeheBeiX(breiteMM, hs, xZentriert) {
    var f = schraegeFit(breiteMM, hs);
    return f.m * (xZentriert + breiteMM / 2) + f.b;
  }
  function de1(v) { return v.toFixed(1).replace('.', ','); }

  var FINISH = {
    'EI-NAT': { hell: [214, 176, 128], dunkel: [132, 92, 52], rough: 0.62, clear: 0.04 },
    'EI-WAL': { hell: [150, 99, 58], dunkel: [62, 38, 22], rough: 0.60, clear: 0.05 },
    'EI-SCH': { hell: [74, 70, 66], dunkel: [18, 17, 16], rough: 0.56, clear: 0.06 },
    'EI-LAC': { hell: [218, 182, 136], dunkel: [138, 98, 58], rough: 0.22, clear: 0.55 }
  };
  var FINISH_KEY_BY_NAME = {
    'eiche natur geölt': 'EI-NAT', 'eiche natur geoelt': 'EI-NAT', 'natur geölt': 'EI-NAT',
    'eiche walnuss geölt': 'EI-WAL', 'walnuss geölt': 'EI-WAL',
    'eiche schwarz geölt': 'EI-SCH', 'schwarz geölt': 'EI-SCH',
    'eiche lackiert': 'EI-LAC', 'lackiert': 'EI-LAC'
  };
  function finishKeyFromLabel(label) {
    var k = (label || '').toLowerCase().trim();
    return FINISH_KEY_BY_NAME[k] || 'EI-NAT';
  }

  var TEX_W = 512, TEX_H = 1024, TEX_MM_U = 190, TEX_MM_V = 760;
  function cv(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }

  /* Ein Graustufenfeld: 0 = Pore/Ring (tief, dunkel), 1 = Spiegel (hoch, hell). Einmal pro Seite
     erzeugt (nicht pro Viewer-Instanz), identisch zu konfigurator.html. */
  var GRAIN = null;
  function maserung() {
    var c = cv(TEX_W, TEX_H), g = c.getContext('2d');
    g.fillStyle = '#808080'; g.fillRect(0, 0, TEX_W, TEX_H);
    var x = -20;
    while (x < TEX_W + 20) {
      var br = 0.8 + Math.random() * 2.6, dk = 40 + Math.random() * 55;
      var amp = 2 + Math.random() * 11, ph = Math.random() * Math.PI * 2, fr = 0.6 + Math.random() * 1.5;
      g.strokeStyle = 'rgba(0,0,0,' + (dk / 255).toFixed(3) + ')';
      g.lineWidth = br; g.beginPath();
      for (var y = 0; y <= TEX_H; y += 6) {
        var t = y / TEX_H;
        var xx = x + Math.sin(ph + t * Math.PI * 2 * fr) * amp + Math.sin(ph * 2 + t * Math.PI * 6) * amp * 0.25;
        if (y === 0) g.moveTo(xx, y); else g.lineTo(xx, y);
      }
      g.stroke();
      x += 3 + Math.random() * 11;
    }
    for (var i = 0; i < 9000; i++) {
      var px = Math.random() * TEX_W, py = Math.random() * TEX_H;
      var len = 1.5 + Math.random() * 7, a = 0.10 + Math.random() * 0.30;
      g.fillStyle = 'rgba(0,0,0,' + a.toFixed(3) + ')';
      g.fillRect(px, py, Math.random() < 0.75 ? 1 : 2, len);
    }
    for (var j = 0; j < 220; j++) {
      var qx = Math.random() * TEX_W, qy = Math.random() * TEX_H, w = 4 + Math.random() * 26;
      g.fillStyle = 'rgba(255,255,255,' + (0.05 + Math.random() * 0.16).toFixed(3) + ')';
      g.fillRect(qx, qy, w, Math.random() < 0.6 ? 1 : 2);
    }
    var im = g.getImageData(0, 0, TEX_W, TEX_H), d = im.data;
    for (var yy = 0; yy < TEX_H; yy++) {
      var n = 0;
      for (var xxx = 0; xxx < TEX_W; xxx++) {
        n = n * 0.55 + (Math.random() - 0.5) * 26;
        var i4 = (yy * TEX_W + xxx) * 4;
        d[i4] = d[i4 + 1] = d[i4 + 2] = Math.max(0, Math.min(255, d[i4] + n));
      }
    }
    g.putImageData(im, 0, 0);
    return g.getImageData(0, 0, TEX_W, TEX_H).data;
  }
  function albedoCanvas(key) {
    var f = FINISH[key], c = cv(TEX_W, TEX_H), g = c.getContext('2d');
    var im = g.createImageData(TEX_W, TEX_H), d = im.data, s = GRAIN;
    for (var i = 0; i < d.length; i += 4) {
      var t = Math.pow(s[i] / 255, 1.15);
      d[i] = f.dunkel[0] + (f.hell[0] - f.dunkel[0]) * t;
      d[i + 1] = f.dunkel[1] + (f.hell[1] - f.dunkel[1]) * t;
      d[i + 2] = f.dunkel[2] + (f.hell[2] - f.dunkel[2]) * t;
      d[i + 3] = 255;
    }
    g.putImageData(im, 0, 0);
    return c;
  }
  function roughCanvas(base) {
    var c = cv(TEX_W, TEX_H), g = c.getContext('2d');
    var im = g.createImageData(TEX_W, TEX_H), d = im.data, s = GRAIN;
    for (var i = 0; i < d.length; i += 4) {
      var v = Math.max(0, Math.min(255, (base + (1 - s[i] / 255) * 0.30) * 255));
      d[i] = d[i + 1] = d[i + 2] = v; d[i + 3] = 255;
    }
    g.putImageData(im, 0, 0);
    return c;
  }
  function normalCanvas(staerke) {
    var c = cv(TEX_W, TEX_H), g = c.getContext('2d');
    var im = g.createImageData(TEX_W, TEX_H), d = im.data, s = GRAIN;
    var at = function (x, y) { return s[(((y + TEX_H) % TEX_H) * TEX_W + ((x + TEX_W) % TEX_W)) * 4] / 255; };
    for (var y = 0; y < TEX_H; y++) {
      for (var x = 0; x < TEX_W; x++) {
        var dx = (at(x + 1, y) - at(x - 1, y)) * staerke;
        var dy = (at(x, y + 1) - at(x, y - 1)) * staerke;
        var nx = -dx, ny = -dy, nz = 1, l = Math.hypot(nx, ny, nz);
        nx /= l; ny /= l; nz /= l;
        var i4 = (y * TEX_W + x) * 4;
        d[i4] = (nx * 0.5 + 0.5) * 255; d[i4 + 1] = (ny * 0.5 + 0.5) * 255; d[i4 + 2] = (nz * 0.5 + 0.5) * 255; d[i4 + 3] = 255;
      }
    }
    g.putImageData(im, 0, 0);
    return c;
  }
  function envCanvas() {
    var c = cv(512, 256), g = c.getContext('2d');
    var lg = g.createLinearGradient(0, 0, 0, 256);
    lg.addColorStop(0, '#fff6e6'); lg.addColorStop(0.42, '#f4efe4');
    lg.addColorStop(0.52, '#e6dccc'); lg.addColorStop(1, '#6f6a5a');
    g.fillStyle = lg; g.fillRect(0, 0, 512, 256);
    var wg = g.createRadialGradient(150, 70, 5, 150, 70, 120);
    wg.addColorStop(0, 'rgba(255,255,255,1)'); wg.addColorStop(1, 'rgba(255,255,255,0)');
    g.fillStyle = wg; g.fillRect(0, 0, 512, 256);
    return c;
  }
  function schattenTex() {
    var c = cv(256, 256), g = c.getContext('2d');
    var r = g.createRadialGradient(128, 128, 4, 128, 128, 126);
    r.addColorStop(0, 'rgba(30,26,20,.46)'); r.addColorStop(0.45, 'rgba(30,26,20,.2)'); r.addColorStop(1, 'rgba(30,26,20,0)');
    g.fillStyle = r; g.fillRect(0, 0, 256, 256);
    return new THREE.CanvasTexture(c);
  }

  var ARTEN = { 'boden-decke': ['boden', 'decke'], 'boden-wand': ['boden', 'wand'], 'decke-wand': ['decke', 'wand'] };
  var ART_NAME = { 'boden-decke': 'Boden + Decke', 'boden-wand': 'Boden + Wand', 'decke-wand': 'Decke + Wand' };
  var SEITE_NAME = { boden: 'Boden', decke: 'Decke', wand: 'Wand' };

  /* ------------------------------------------------------------------ *
   * Eine Viewer-Instanz pro Section-Root (Theme erlaubt mehrere Sections
   * pro Seite -- deshalb Factory statt Top-Level-Globals wie im Original
   * konfigurator.html, das von genau einer Instanz pro HTML-Dokument ausging).
   * ------------------------------------------------------------------ */
  function createViewer(root, viewerBlock) {
    var viewport = Q(viewerBlock, '[data-rt3d-viewport]');
    if (!viewport) return;
    var loading = Q(viewerBlock, '[data-rt3d-loading]');
    var hint = Q(viewerBlock, '[data-rt3d-hint]');
    var scaleEl = Q(viewerBlock, '[data-rt3d-scale]');

    if (typeof THREE === 'undefined') {
      if (loading) loading.textContent = '3D-Vorschau nicht verfügbar';
      return;
    }
    if (!GRAIN) GRAIN = maserung();

    var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: false });
    renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.05;
    viewport.appendChild(renderer.domElement);

    var scene = new THREE.Scene();
    scene.background = new THREE.Color(0xfffdfa);
    var camera = new THREE.PerspectiveCamera(32, 1, 0.05, 60);

    var pmrem = new THREE.PMREMGenerator(renderer);
    pmrem.compileEquirectangularShader();
    var envTex = new THREE.CanvasTexture(envCanvas());
    envTex.mapping = THREE.EquirectangularReflectionMapping;
    envTex.encoding = THREE.sRGBEncoding;
    scene.environment = pmrem.fromEquirectangular(envTex).texture;

    scene.add(new THREE.HemisphereLight(0xfff4e2, 0x8a7a66, 0.45));
    var key = new THREE.DirectionalLight(0xfff1dc, 1.5); key.position.set(2.4, 3.2, 2.0); scene.add(key);
    var fill = new THREE.DirectionalLight(0xdfe6e4, 0.35); fill.position.set(-2.6, 1.2, -1.4); scene.add(fill);

    var schatten = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), new THREE.MeshBasicMaterial({ map: schattenTex(), transparent: true, depthWrite: false }));
    schatten.rotation.x = -Math.PI / 2; schatten.position.y = 0.001;
    scene.add(schatten);

    var mat = new THREE.MeshPhysicalMaterial({ roughness: 0.6, metalness: 0, clearcoat: 0.04, clearcoatRoughness: 0.35, envMapIntensity: 0.9 });
    function texFrom(c, srgb) {
      var t = new THREE.CanvasTexture(c);
      t.wrapS = t.wrapT = THREE.RepeatWrapping;
      t.anisotropy = renderer.capabilities.getMaxAnisotropy();
      if (srgb) t.encoding = THREE.sRGBEncoding;
      return t;
    }
    mat.normalMap = texFrom(normalCanvas(1.5), false);
    mat.normalScale = new THREE.Vector2(0.55, 0.55);

    var finish = 'EI-NAT';
    function setFinish(k) {
      if (k === finish && mat.map) return;
      finish = k;
      var f = FINISH[k] || FINISH['EI-NAT'];
      if (mat.map) mat.map.dispose();
      if (mat.roughnessMap) mat.roughnessMap.dispose();
      mat.map = texFrom(albedoCanvas(k), true);
      mat.roughnessMap = texFrom(roughCanvas(f.rough), false);
      mat.roughness = 1.0;
      mat.clearcoat = f.clear;
      mat.clearcoatRoughness = k === 'EI-LAC' ? 0.10 : 0.35;
      mat.needsUpdate = true;
    }
    setFinish('EI-NAT');

    /* kipp (optional, m): nur fuer die Dachschraege. Schert die OBERE Kante entlang der lokalen
       Breite w -- die -x-Seite sinkt um kipp/2, die +x-Seite steigt um kipp/2, der Boden bleibt
       flach. h bleibt damit die MITTLERE Hoehe des Bauteils. Ohne kipp ein einfacher Quader. */
    function quader(w, h, d, uOff, vOff, tausch, kipp) {
      var g = new THREE.BoxGeometry(w, h, d);
      var uv = g.attributes.uv;
      var spans = [[d, h], [d, h], [w, d], [w, d], [w, h], [w, h]];
      for (var f = 0; f < 6; f++) {
        for (var i = 0; i < 4; i++) {
          var j = f * 4 + i;
          var u = uv.getX(j), v = uv.getY(j);
          var su = spans[f][0] * 1000 / TEX_MM_U, sv = spans[f][1] * 1000 / TEX_MM_V;
          if (tausch) { var t = u; u = v; v = t; var ts = su; su = sv; sv = ts; }
          uv.setXY(j, u * su + uOff, v * sv + vOff);
        }
      }
      uv.needsUpdate = true;
      if (kipp) {
        var pos = g.attributes.position;
        for (var pi = 0; pi < pos.count; pi++) {
          var px = pos.getX(pi), py = pos.getY(pi);
          if (py > 0) pos.setY(pi, py + (px / w) * kipp);
        }
        pos.needsUpdate = true;
        g.computeVertexNormals();
      }
      return g;
    }

    var gruppe = new THREE.Group(); scene.add(gruppe);
    var raum = new THREE.Group(); scene.add(raum);
    var kappenMat = new THREE.MeshStandardMaterial({ color: 0x6e4d2f, roughness: 0.55 });
    var raumMat = new THREE.MeshStandardMaterial({ color: 0xd4c1a8, transparent: true, opacity: 0.28, side: THREE.DoubleSide, depthWrite: false });
    var breiteM = 0.99, hoeheM = 3.0, zielY = 1.5;

    /* Montage- und Regal-Zustand. Boden/Decke Schrauben-Kleben wird von der echten,
       bestellbaren UI (assets/raumteiler-konfigurator.js, [data-rt-set]) gespiegelt -- diese
       Instanz liest sie nur, sie besitzt nur "wand" (reine Vorschau, siehe Sektions-Kommentar). */
    var M = { art: 'boden-decke', wandSeite: 'links', fbh: 'nein', bef: { boden: 'schrauben', decke: 'schrauben', wand: 'schrauben' },
              deckenart: 'gerade', schraege: [null, null, null] /* Messpunkte in mm, null = noch nicht eingegeben */ };

    /* Dachschraege ist bei JEDER Montageart waehlbar (Wunsch 13.10.2026). Quelle (konfigurator.html)
       kennt sie nur bei Boden + Decke; bei Boden + Wand und Decke + Wand gilt dieselbe Geometrie
       (Unterkante waagerecht, Oberkante folgt der Ausgleichsgeraden) -- dort Design-Vorschau, siehe
       Hinweis im Deckenart-Block. */
    function schraegeAktiv() { return M.deckenart === 'schraege'; }
    function punkteGueltig(punkte) {
      return punkte.every(function (v) { return typeof v === 'number' && v >= SCHRAEGE_MIN && v <= SCHRAEGE_MAX; });
    }
    /* Werte fuer die Darstellung: fehlende/ungueltige Punkte werden mit dem letzten gueltigen Wert
       (sonst 3000) aufgefuellt -- das Modell soll immer baubar sein. Bestellbar ist es erst, wenn
       punkteGueltig() fuer die ECHTEN Eingaben stimmt (siehe syncRaumhoehe). */
    function schraegeWerte(n) {
      var out = [], last = SCHRAEGE_MAX;
      for (var i = 0; i < n; i++) {
        var v = M.schraege[i];
        if (typeof v === 'number' && v >= SCHRAEGE_MIN && v <= SCHRAEGE_MAX) last = v;
        out.push(last);
      }
      return out;
    }
    var REG = { aktiv: false, k: PROGRAMM.regal.k_optionen[PROGRAMM.regal.k_optionen.length - 1].k, start: 0, n: 5, heights: [] };

    var montageSeiten = function () { return ARTEN[M.art]; };

    function bohrFugen(e) {
      var n = e.n, last = n - 2;
      var f = [0, last];
      if (e.elemente === 2) { var mid = Math.round((n - 1) / 2); f.push(mid - 1, mid); }
      var uniq = f.filter(function (v, i) { return f.indexOf(v) === i; });
      uniq.sort(function (a, b) { return a - b; });
      return uniq;
    }

    function regZMin() { return PROGRAMM.profil.leiste_h + PROGRAMM.regal.rand_leiste; }
    function regZMax(hMM) { var R = PROGRAMM.regal; return hMM - PROGRAMM.profil.leiste_h - R.rand_leiste - R.board_t; }
    function regMaxBoeden(hMM) { var span = regZMax(hMM) - regZMin(); return Math.max(1, Math.floor(span / PROGRAMM.regal.rand_boden) + 1); }
    function regHoehen(n, hMM) {
      var zMin = regZMin(), zMax = regZMax(hMM);
      if (n <= 1) return [(zMin + zMax) / 2];
      var schritt = (zMax - zMin) / (n - 1);
      var out = [];
      for (var i = 0; i < n; i++) out.push(zMin + i * schritt);
      return out;
    }
    function regHeightsReset(n, hMM) { REG.heights = regHoehen(n, hMM).map(Math.round); }

    /* eintrag = Eintrag aus PROGRAMM.breiten (geometrische Breite = eintrag.breite, NICHT der
       Shopify-Variantenwert), hMM = Bauhoehe (bei Dachschraege: Mitte). */
    function bauen(eintrag, hMM) {
      while (gruppe.children.length) { var c = gruppe.children.pop(); c.geometry.dispose(); gruppe.remove(c); }
      var P = PROGRAMM.profil;
      var m = function (v) { return v / 1000; };
      var B = m(eintrag.breite), H = m(hMM);
      var LB = m(P.lamelle_b), LT = m(P.lamelle_t), R = m(P.raster);
      var LH = m(P.leiste_h), PB = m(P.pfosten_b);
      var lamL = H - 2 * LH, leisteL = B - 2 * PB, nRaster = eintrag.n;

      var add = function (g, x, y, z) { var msh = new THREE.Mesh(g, mat); msh.position.set(x, y, z); gruppe.add(msh); return msh; };
      var xZelle = function (cell) { return -B / 2 + LB / 2 + cell * R; };

      /* Dachschraege: topZ(x) = absolute Hoehe (ab Boden) der Deckenseite an Stelle x [m], dort sitzt
         die AUSSENSEITE der oberen Leiste (5 mm Einbauluft). theta = Neigungswinkel der Ausgleichsgeraden. */
      var sAktiv = schraegeAktiv();
      var theta = 0, topZ = function () { return H; };
      if (sAktiv) {
        var sw = schraegeWerte(schraegePunkteAnzahl(eintrag.breite));
        theta = Math.atan(schraegeFit(eintrag.breite, sw).m);
        topZ = function (xMeter) { return m(schraegeHoeheBeiX(eintrag.breite, sw, xMeter * 1000) - 5); };
      }

      var regal = null;
      if (REG.aktiv) {
        var kOpt = null;
        for (var ko = 0; ko < PROGRAMM.regal.k_optionen.length; ko++) { if (PROGRAMM.regal.k_optionen[ko].k === REG.k) { kOpt = PROGRAMM.regal.k_optionen[ko]; break; } }
        if (!kOpt) kOpt = PROGRAMM.regal.k_optionen[0];
        var start = Math.max(0, Math.min(nRaster - kOpt.k, REG.start));
        regal = { start: start, ende: start + kOpt.k - 1, kOpt: kOpt };
      }

      /* Leisten oben/unten (Laengsachse X, deshalb UV vertauscht). Unten immer waagerecht. Oben mit
         Dachschraege ein STARRER, um theta gedrehter Koerper (laenge / cos(theta), damit die Projektion
         auf die Breite nach dem Drehen nicht zu kurz ist). */
      add(quader(leisteL, LH, LT, 0, 0, true), 0, LH / 2, 0);
      if (sAktiv) {
        var oben = add(quader(leisteL / Math.cos(theta), LH, LT, 0, 1.7, true), 0, topZ(0) - LH / 2, 0);
        oben.rotation.z = theta;
      } else {
        add(quader(leisteL, LH, LT, 0, 1.7, true), 0, H - LH / 2, 0);
      }

      /* Endpfosten laufen vom Boden bis zur Oberkante (bei Dachschraege je Seite unterschiedlich hoch);
         die Oberkante wird wie bei der Lamelle geschert, nicht gedreht. */
      var xa = B / 2 - PB / 2;
      var kippPfosten = sAktiv ? Math.tan(theta) * PB : 0;
      var topPfostenL = sAktiv ? topZ(-xa) : H;
      var topPfostenR = sAktiv ? topZ(xa) : H;
      add(quader(PB, topPfostenL, LT, 0, 0.0, false, kippPfosten), -xa, topPfostenL / 2, 0);
      add(quader(PB, topPfostenR, LT, 0, 3.1, false, kippPfosten), xa, topPfostenR / 2, 0);

      /* Lamellen zwischen den Leisten; vom Regal belegte Zellen entfallen ersatzlos. Bei Dachschraege
         hat jede Lamelle ihre eigene Hoehe (flacher Boden, geschertes Oberende). */
      var kippLamelle = sAktiv ? Math.tan(theta) * LB : 0;
      var lamellenGebaut = 0;
      for (var li = 1; li <= eintrag.lamellen; li++) {
        if (regal && li > regal.start && li < regal.ende) continue;
        var xc = xZelle(li);
        var hoehe_i = sAktiv ? topZ(xc) - 2 * LH : lamL;
        var mid_i = sAktiv ? topZ(xc) / 2 : LH + lamL / 2;
        add(quader(LB, hoehe_i, LT, (li % 3) * 0.37, (li * 2.13) % 5, false, kippLamelle), xc, mid_i, 0);
        lamellenGebaut++;
      }

      if (regal) {
        var R2 = PROGRAMM.regal;
        var boardW = m(regal.kOpt.klar), boardT = m(R2.board_t), tiefe = m(R2.tiefe);
        var xMitte = (xZelle(regal.start) + xZelle(regal.ende)) / 2;
        REG.heights.forEach(function (z0, idx) {
          add(quader(boardW, boardT, tiefe, (idx % 3) * 0.41, (idx * 1.7) % 4, false), xMitte, m(z0) + boardT / 2, 0);
        });
      }

      var seiten = montageSeiten();
      var bohrungen = 0;
      var kappe = function (x, y, z, achse) {
        var g = new THREE.CylinderGeometry(0.007, 0.007, 0.003, 20);
        var msh = new THREE.Mesh(g, kappenMat);
        if (achse === 'x') msh.rotation.z = Math.PI / 2;
        msh.position.set(x, y, z); gruppe.add(msh); bohrungen++;
      };
      var fx = bohrFugen(eintrag).map(function (f) { return xZelle(f) + R / 2; });
      if (seiten.indexOf('boden') > -1 && M.bef.boden === 'schrauben') fx.forEach(function (x) { kappe(x, LH + 0.0015, 0, 'y'); });
      if (seiten.indexOf('decke') > -1 && M.bef.decke === 'schrauben') fx.forEach(function (x) { kappe(x, (sAktiv ? topZ(x) : H) - LH - 0.0015, 0, 'y'); });
      if (seiten.indexOf('wand') > -1 && M.bef.wand === 'schrauben') {
        var sg = M.wandSeite === 'links' ? -1 : 1;
        var xi = sg * (B / 2 - PB - 0.0015);
        [LH + 0.3, H / 2, H - LH - 0.3].forEach(function (y) { kappe(xi, y, 0, 'x'); });
      }

      while (raum.children.length) { var rc = raum.children.pop(); rc.geometry.dispose(); }
      var mitDecke = seiten.indexOf('decke') > -1;
      /* Vereinfachung ggue. konfigurator.html: dort steuert ein eigenes Stichmass-Trio die Raumhoehe
         getrennt von der Bauhoehe (inkl. haengendem Versatz bei "Decke + Wand"). Hier gibt es nur
         Rt's einen Raumhoehe-Block: hMM ist immer = Bauhoehe, kein Bodenabstand bei "Decke + Wand". */
      if (mitDecke || sAktiv) {
        if (sAktiv) {
          var dSchraeg = new THREE.Mesh(new THREE.BoxGeometry((B + 0.6) / Math.cos(theta), 0.02, 0.5), raumMat);
          dSchraeg.rotation.z = theta;
          dSchraeg.position.set(0, topZ(0) + 0.01, 0); raum.add(dSchraeg);
        } else {
          var dMesh = new THREE.Mesh(new THREE.BoxGeometry(B + 0.6, 0.02, 0.5), raumMat);
          dMesh.position.set(0, H + 0.01, 0); raum.add(dMesh);
        }
      }
      if (seiten.indexOf('wand') > -1) {
        var sgw = M.wandSeite === 'links' ? -1 : 1;
        var wh = (sAktiv ? Math.max(topZ(-B / 2), topZ(B / 2)) : H) + 0.3;
        var wMesh = new THREE.Mesh(new THREE.BoxGeometry(0.02, wh, 0.5), raumMat);
        wMesh.position.set(sgw * (B / 2 + 0.01), wh / 2, 0); raum.add(wMesh);
      }

      breiteM = B;
      hoeheM = sAktiv ? Math.max(topZ(-B / 2), topZ(B / 2)) : H;
      zielY = hoeheM / 2;
      schatten.scale.set(B * 1.5, LT * 9, 1);
      schatten.position.set(0, 0.001, 0);
      rahmen();
      return { n: eintrag.n, lamellen: lamellenGebaut, bohrungen: bohrungen, regal: regal, elemente: eintrag.elemente };
    }

    var az = 0.62, pol = 1.30, dist = 6;
    function rahmen() {
      var r = Math.hypot(breiteM, hoeheM) / 2;
      var fov = camera.fov * Math.PI / 180;
      dist = r / Math.tan(fov / 2) * 1.18;
    }
    function kamera() {
      var ziel = new THREE.Vector3(0, zielY, 0);
      camera.position.set(ziel.x + dist * Math.sin(pol) * Math.sin(az), ziel.y + dist * Math.cos(pol), ziel.z + dist * Math.sin(pol) * Math.cos(az));
      camera.lookAt(ziel);
    }

    var zieht = false, lx = 0, ly = 0, autodreh = true;
    var el = renderer.domElement;
    el.addEventListener('pointerdown', function (e) { zieht = true; autodreh = false; lx = e.clientX; ly = e.clientY; el.setPointerCapture(e.pointerId); if (hint) hint.classList.add('is-hidden'); });
    el.addEventListener('pointermove', function (e) { if (!zieht) return; az -= (e.clientX - lx) * 0.008; pol = Math.max(0.32, Math.min(2.05, pol - (e.clientY - ly) * 0.006)); lx = e.clientX; ly = e.clientY; });
    addEventListener('pointerup', function () { zieht = false; });
    el.addEventListener('wheel', function (e) { e.preventDefault(); autodreh = false; dist = Math.max(1.1, Math.min(22, dist * (1 + Math.sign(e.deltaY) * 0.09))); }, { passive: false });

    function groesse() {
      var w = viewport.clientWidth, h = viewport.clientHeight;
      if (!w || !h) return;
      renderer.setSize(w, h, false);
      camera.aspect = w / h; camera.updateProjectionMatrix();
      if (scaleEl) {
        var proj = 2 * Math.tan(camera.fov * Math.PI / 360) * dist;
        var mmProPx = proj / h * 1000, mm = 44 * mmProPx;
        scaleEl.textContent = mm >= 1000 ? (mm / 1000).toFixed(1).replace('.', ',') + ' m' : Math.round(mm / 10) * 10 + ' mm';
      }
    }
    var resizeObs = (typeof ResizeObserver !== 'undefined') ? new ResizeObserver(groesse) : null;
    if (resizeObs) resizeObs.observe(viewport); else addEventListener('resize', groesse);

    var mag = window.matchMedia('(prefers-reduced-motion: reduce)');
    var rafId = null;
    function tick() {
      rafId = requestAnimationFrame(tick);
      if (autodreh && !mag.matches) az += 0.0016;
      kamera();
      renderer.render(scene, camera);
    }

    /* ---------------- DOM-Bindung: Breite/Hoehe aus dem bestehenden Rt-DOM lesen ---------------- */
    var productData = null;
    try { var pj = Q(root, '#rt-product-json'); if (pj) productData = JSON.parse(pj.textContent); } catch (e) { /* noop */ }
    var optBreite = root.dataset.optBreite;

    function currentWidthMM() {
      var sel = Q(root, '[data-rt-select]');
      if (sel && sel.value) return +sel.value;
      var range = Q(root, '[data-rt-range]');
      if (range && productData && productData.variants && optBreite) {
        var key = 'option' + optBreite;
        var widths = productData.variants.map(function (v) { return +v[key]; }).filter(function (v) { return !isNaN(v); });
        widths = widths.filter(function (v, i) { return widths.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
        var idx = +range.value;
        if (widths[idx] !== undefined) return widths[idx];
      }
      return NaN;
    }
    /* Geometrie-Eintrag zur gewaehlten Variante (siehe eintragFuerBreite). Nur wenn gar keine Breite
       lesbar ist (kein Select/Range im DOM), greift der Standardeintrag n = 13. */
    function currentEintrag() {
      return eintragFuerBreite(currentWidthMM()) || PROGRAMM.breiten[6];
    }
    function currentHeightMM() {
      if (schraegeAktiv()) {
        /* Bauhoehe = Deckenhoehe in der Mitte minus 5 mm Einbauluft (wie hoeheSync() in der Quelle) */
        var eS = currentEintrag();
        var wS = schraegeWerte(schraegePunkteAnzahl(eS.breite));
        return Math.round(schraegeHoeheBeiX(eS.breite, wS, 0) - 5);
      }
      var h = Q(root, '[data-rt-hoehe]');
      var raumhoeheCm = h && h.value ? +h.value : null;
      if (raumhoeheCm && raumhoeheCm >= 180 && raumhoeheCm <= 300) return Math.round((raumhoeheCm - 0.5) * 10);
      return PROGRAMM.hoehe_standard;
    }
    function currentOberflaecheLabel() {
      var checked = Q(root, 'input[name="rt-oberflaeche"]:checked');
      return checked ? checked.value : (Q(root, '[data-rt-txt="oberflaeche"]') || {}).textContent;
    }
    function readBefState(pos) {
      var pressed = Q(root, '[data-rt-bef="' + pos + '"] [data-rt-set="' + pos + '"][aria-pressed="true"]');
      return pressed ? pressed.dataset.value : 'schrauben';
    }

    /* ---------------- Dachschraege: Zustand nach aussen + Raumhoehe-Feld von Rt fuehren ---------------- */
    var hoeheEl = Q(root, '[data-rt-hoehe]');
    var raumhoeheVorSchraege = null, schraegeBelegt = false;

    function punkteFuer(eintrag) {
      var n = schraegePunkteAnzahl(eintrag.breite);
      /* Andere Punktzahl = andere Messpositionen (0 / B/2 / B  vs.  0 / B/3 / 2B/3 / B): alte Werte
         waeren am falschen Ort gemessen -> zuruecksetzen, der Kunde misst neu. */
      if (M.schraege.length !== n) { M.schraege = []; for (var i = 0; i < n; i++) M.schraege.push(null); }
      return M.schraege;
    }
    function deckenInfo(eintrag) {
      var punkte = punkteFuer(eintrag), n = punkte.length;
      var w = schraegeWerte(n);
      var fit = schraegeFit(eintrag.breite, w);
      var pos = [];
      for (var i = 0; i < n; i++) pos.push(Math.round(i * eintrag.breite / (n - 1)));
      var gueltigeWerte = punkte.filter(function (v) { return typeof v === 'number'; });
      return {
        moeglich: true,
        art: M.art,
        artName: ART_NAME[M.art],
        aktiv: schraegeAktiv(),
        n: n,
        breite: eintrag.breite,
        positionen: pos,
        punkte: punkte.slice(),
        gueltig: punkteGueltig(punkte),
        winkel: +(Math.atan(fit.m) * 180 / Math.PI).toFixed(1),
        mitte: Math.round(schraegeHoeheBeiX(eintrag.breite, w, 0)),
        kleinster: gueltigeWerte.length ? Math.min.apply(null, gueltigeWerte) : null
      };
    }
    /* Rt kennt nur EIN Raumhoehe-Feld (cm, 180-300, Pflicht). Bei Dachschraege fuehrt diese Schicht es
       mit der Mitte der Schraege (ganze cm) -- so bleiben Rt's Pflichtpruefung und Preis-/Variantenlogik
       unveraendert. Sind die Messpunkte unvollstaendig, bleibt das Feld LEER: Rt blockiert dann den
       Warenkorb mit seiner Raumhoehe-Meldung statt mit erfundenen Standardwerten zu bestellen.
       Beim Zurueckschalten auf "gerade" kommt der vorher eingegebene Wert zurueck. */
    function setzeRaumhoehe(v) {
      if (!hoeheEl || hoeheEl.value === v) return;
      hoeheEl.value = v;
      hoeheEl.dispatchEvent(new Event('input', { bubbles: true }));
    }
    function syncRaumhoehe(info) {
      if (!hoeheEl) return;
      if (info.aktiv) {
        if (!schraegeBelegt) { raumhoeheVorSchraege = hoeheEl.value; schraegeBelegt = true; }
        var cm = Math.round(info.mitte / 10);
        setzeRaumhoehe(info.gueltig && cm >= 180 && cm <= 300 ? String(cm) : '');
      } else if (schraegeBelegt) {
        schraegeBelegt = false;
        setzeRaumhoehe(raumhoeheVorSchraege || '');
      }
    }

    /* ---------------- Zusammenfassung (erweitert die bestehende <dl class="rt-summary">) ---------------- */
    function updateSummary(letzterBau, info) {
      QA(viewerBlock, '[data-rt3d-txt="montageart"]').forEach(function (el) { el.textContent = ART_NAME[M.art]; });
      var row = Q(viewerBlock, '[data-rt3d-row="regal"]');
      if (row) row.hidden = !REG.aktiv;
      QA(viewerBlock, '[data-rt3d-txt="regal"]').forEach(function (el) {
        el.textContent = REG.aktiv ? 'Mit Regal (' + REG.heights.length + ' Böden, nur Vorschau)' : 'Ohne';
      });
      var dRow = Q(viewerBlock, '[data-rt3d-row="deckenart"]');
      if (dRow) dRow.hidden = !info.aktiv;
      QA(viewerBlock, '[data-rt3d-txt="deckenart"]').forEach(function (el) {
        el.textContent = 'Dachschräge, ' + de1(info.winkel) + '° · Raumhöhe Mitte ≈ ' + info.mitte + ' mm (nur Vorschau)';
      });
      /* Rt schreibt hier die aus ganzen cm gerundete Mitte; die Schraege kennt die genaue Bauhoehe. */
      if (info.aktiv) QA(root, '[data-rt-txt="bauhoehe"]').forEach(function (el) { el.textContent = de1((info.mitte - 5) / 10) + ' cm (Mitte)'; });
    }

    function rebuild() {
      var eintrag = currentEintrag();
      var info = deckenInfo(eintrag);
      syncRaumhoehe(info);
      var hMM = currentHeightMM();
      M.bef.boden = readBefState('boden');
      M.bef.decke = readBefState('decke');
      var oberLabel = currentOberflaecheLabel();
      setFinish(finishKeyFromLabel(oberLabel));
      if (REG.aktiv) { regHeightsReset(REG.n, hMM); }
      var b = bauen(eintrag, hMM);
      updateSummary(b, info);
      viewerBlock.dispatchEvent(new CustomEvent('rt3d:decken-sync', { detail: info, bubbles: true }));
      if (loading) { loading.remove(); }
      viewport.setAttribute('data-rt3d-ready', '1');
      groesse();
    }

    var scheduled = false;
    function scheduleRebuild() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; rebuild(); });
    }

    /* Reagiert auf denselben State wie die Original-Rt-Klasse: variant:change (Rt feuert es bei
       jeder Varianten-Aenderung), sowie generisch auf input/change/click auf dem geteilten Root
       (Rt selbst bindet ihre Listener ebenfalls auf `root`, mehrere Listener koexistieren). */
    root.addEventListener('variant:change', scheduleRebuild);
    root.addEventListener('input', scheduleRebuild);
    root.addEventListener('change', scheduleRebuild);
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-rt-set]')) scheduleRebuild();
    });

    tick();
    rebuild();

    function setNested(obj, path, value) {
      var parts = path.split('.'), o = obj;
      for (var i = 0; i < parts.length - 1; i++) o = o[parts[i]];
      o[parts[parts.length - 1]] = value;
    }

    function regalSyncInfo() {
      var eintrag = currentEintrag();
      var kOpt = null;
      PROGRAMM.regal.k_optionen.forEach(function (o) { if (o.k === REG.k) kOpt = o; });
      if (!kOpt) kOpt = PROGRAMM.regal.k_optionen[PROGRAMM.regal.k_optionen.length - 1];
      var maxStart = Math.max(0, eintrag.n - kOpt.k);
      if (REG.start > maxStart) REG.start = maxStart;
      var hMM = currentHeightMM();
      var maxN = Math.min(5, regMaxBoeden(hMM));
      if (REG.n > maxN) REG.n = maxN;
      return { kLabel: kOpt.aussen + ' mm', maxStart: maxStart, maxN: maxN };
    }

    function emitBoardRows() {
      viewerBlock.dispatchEvent(new CustomEvent('rt3d:board-rows-render', { detail: { heights: REG.heights.slice() }, bubbles: true }));
    }
    function emitRegalSync() {
      viewerBlock.dispatchEvent(new CustomEvent('rt3d:regal-sync', { detail: regalSyncInfo(), bubbles: true }));
    }

    var api = {
      root: root,
      viewerBlock: viewerBlock,
      rebuild: scheduleRebuild,
      _Mset: function (path, value) {
        setNested(M, path, value);
      },
      _REGset: function (key, value) {
        REG[key] = value;
        if (key === 'aktiv' && value) {
          regHeightsReset(REG.n, currentHeightMM());
        }
        if (key === 'n') regHeightsReset(REG.n, currentHeightMM());
        emitRegalSync();
        emitBoardRows();
      },
      _REGeven: function () {
        regHeightsReset(REG.n, currentHeightMM());
        emitBoardRows();
      },
      _boardChange: function (i, v) {
        var hMM = currentHeightMM();
        var zMin = regZMin(), zMax = regZMax(hMM);
        var lo = i === 0 ? zMin : REG.heights[i - 1] + PROGRAMM.regal.rand_boden;
        var hi = i === REG.heights.length - 1 ? zMax : REG.heights[i + 1] - PROGRAMM.regal.rand_boden;
        REG.heights[i] = Math.max(lo, Math.min(hi, Math.round(v)));
      },
      _boardCommit: function () {
        emitBoardRows();
      },
      /* Messpunkt i (0-basiert) der Dachschraege setzen; v = Zahl in mm oder null (leer). */
      _SCHRset: function (i, v) {
        punkteFuer(currentEintrag());
        if (i >= 0 && i < M.schraege.length) M.schraege[i] = v;
      },
      getHeightMM: currentHeightMM,
      getRegalState: function () {
        var kOpt = null;
        PROGRAMM.regal.k_optionen.forEach(function (o) { if (o.k === REG.k) kOpt = o; });
        if (!kOpt) kOpt = PROGRAMM.regal.k_optionen[PROGRAMM.regal.k_optionen.length - 1];
        return {
          aktiv: REG.aktiv,
          k: REG.k,
          kAussenMM: kOpt.aussen,
          start: REG.start,
          startMM: Math.round(REG.start * PROGRAMM.profil.raster),
          n: REG.n,
          heights: REG.heights.slice()
        };
      }
    };
    return api;
  }

  /* ------------------------------------------------------------------ *
   * Montageart / Befestigung-Wand / Regal: Bedienung der neuen Bloecke.
   * Reine UI-Logik auf dem jeweiligen Root, unabhaengig von Rt.
   * ------------------------------------------------------------------ */
  function pressed(cont, val) {
    if (!cont) return;
    QA(cont, '[aria-pressed]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.value === val)); });
  }

  function bindMontageart(root) {
    var block = Q(root, '[data-rt3d-montageart]');
    if (!block) return;

    function syncWandBlocks(art) {
      var seiten = ARTEN[art];
      QA(root, '[data-rt3d-wand-block]').forEach(function (wb) { wb.hidden = seiten.indexOf('wand') === -1; });
      var fbhBlock = Q(block, '[data-rt3d-fbh-block]');
      if (fbhBlock) fbhBlock.hidden = seiten.indexOf('boden') === -1;
    }

    QA(block, '[data-rt3d-set="art"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var art = btn.dataset.value;
        QA(block, '[data-rt3d-set="art"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        QA(block, '[data-rt3d-txt="montageart-label"]').forEach(function (el) { el.textContent = ART_NAME[art]; });
        syncWandBlocks(art);
        enforceMontageConstraints(root, null);
        root.dispatchEvent(new CustomEvent('rt3d:art-change', { detail: { art: art } }));
      });
    });

    QA(block, '[data-rt3d-set="fbh"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        QA(block, '[data-rt3d-set="fbh"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        enforceMontageConstraints(root, null);
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * Wer darf wann Schrauben/Kleben waehlen -- pro Montageart und (bei
   * Boden beteiligt) Fussbodenheizung. Regeln (Vorgabe des Nutzers):
   *
   *   Boden+Decke: Boden bei FBH ja/unbekannt zwingend Kleben, sonst frei.
   *                Decke IMMER frei (unabhaengig von FBH).
   *   Boden+Wand:  bei FBH ja/unbekannt zwingend Boden=Kleben, Wand=Schrauben.
   *                Bei FBH nein: beide frei, aber NICHT beide Kleben
   *                (mindestens eine Seite muss Schrauben sein).
   *   Decke+Wand:  keine FBH-Frage (kein Bodenkontakt). Immer genau eine
   *                Seite Schrauben, die andere Kleben -- nie beide gleich.
   *
   * Umsetzung als "preventive disable": Buttons, die zu einem verbotenen
   * Zustand fuehren wuerden, werden VORHER disabled, statt hinterher den
   * Klick des Kunden zu ignorieren oder unerwartet eine andere Seite
   * umzuschalten. Nur wenn ein Art-/FBH-Wechsel selbst einen Konflikt
   * erzeugt (z. B. Defaultwerte beider Seiten gleich), wird die Seite
   * korrigiert, die der Kunde NICHT zuletzt selbst angeklickt hat
   * (justChanged). Boden/Decke sind Rt's eigene Buttons ([data-rt-set]) --
   * Korrektur nur per simuliertem Klick + disabled-Attribut, wie schon
   * beim reinen FBH-Zwang zuvor (raumteiler-konfigurator.js bleibt
   * unangetastet, sein render() haelt Preis/Property/aria-pressed konsistent).
   * Wand ist unser eigener Block, voll unter eigener Kontrolle.
   * ------------------------------------------------------------------ */
  function enforceMontageConstraints(root, justChanged) {
    if (root._rt3dEnforcing) return; /* Reentranz-Schutz: simulierte Klicks loesen denselben Handler erneut aus */
    root._rt3dEnforcing = true;
    try {
      var montageBlock = Q(root, '[data-rt3d-montageart]');
      var art = montageBlock ? (Q(montageBlock, '[data-rt3d-set="art"][aria-pressed="true"]') || {}).dataset : null;
      art = (art && art.value) || 'boden-decke';
      var fbhBtn = montageBlock ? Q(montageBlock, '[data-rt3d-set="fbh"][aria-pressed="true"]') : null;
      var fbh = (fbhBtn && fbhBtn.dataset.value) || 'nein';

      var bodenBlock = Q(root, '[data-rt-bef="boden"]');
      var deckeBlock = Q(root, '[data-rt-bef="decke"]');
      var wandBlock = Q(root, '[data-rt3d-wand-block]:not([hidden])') || Q(root, '[data-rt3d-wand-block]');
      var bodenS = bodenBlock && Q(bodenBlock, '[data-rt-set="boden"][data-value="schrauben"]');
      var bodenK = bodenBlock && Q(bodenBlock, '[data-rt-set="boden"][data-value="kleben"]');
      var deckeS = deckeBlock && Q(deckeBlock, '[data-rt-set="decke"][data-value="schrauben"]');
      var deckeK = deckeBlock && Q(deckeBlock, '[data-rt-set="decke"][data-value="kleben"]');
      var wandS = wandBlock && Q(wandBlock, '[data-rt3d-set="wand"][data-value="schrauben"]');
      var wandK = wandBlock && Q(wandBlock, '[data-rt3d-set="wand"][data-value="kleben"]');

      function pressed(btn) { return !!btn && btn.getAttribute('aria-pressed') === 'true'; }
      function force(btn) { if (btn && !pressed(btn) && !btn.disabled) btn.click(); }
      function disable(btn, on) { if (!btn) return; if (on) btn.setAttribute('disabled', ''); else btn.removeAttribute('disabled'); }

      [bodenS, bodenK, deckeS, deckeK, wandS, wandK].forEach(function (b) { disable(b, false); });

      if (art === 'boden-decke') {
        var bodenZwingt = fbh !== 'nein';
        if (bodenZwingt) { force(bodenK); disable(bodenS, true); }
        /* Decke bleibt in jedem Fall frei */
      }

      if (art === 'boden-wand') {
        var zwingt = fbh !== 'nein';
        if (zwingt) {
          force(bodenK); disable(bodenS, true);
          force(wandS); disable(wandK, true);
        } else {
          if (pressed(bodenK) && pressed(wandK)) {
            if (justChanged === 'wand') force(bodenS); else force(wandS);
          }
          disable(wandK, pressed(bodenK));
          disable(bodenK, pressed(wandK));
        }
      }

      if (art === 'decke-wand') {
        if (pressed(deckeS) && pressed(wandS)) {
          if (justChanged === 'wand') force(deckeK); else force(wandK);
        } else if (pressed(deckeK) && pressed(wandK)) {
          if (justChanged === 'wand') force(deckeS); else force(wandS);
        }
        disable(wandS, pressed(deckeS));
        disable(wandK, pressed(deckeK));
        disable(deckeS, pressed(wandS));
        disable(deckeK, pressed(wandK));
      }
    } finally {
      root._rt3dEnforcing = false;
    }
  }

  function bindBefestigungWand(root) {
    QA(root, '[data-rt3d-wand-block]').forEach(function (wandBlock) {
      QA(wandBlock, '[data-rt3d-set="wand"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          QA(wandBlock, '[data-rt3d-set="wand"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
          enforceMontageConstraints(root, 'wand');
          root.dispatchEvent(new CustomEvent('rt3d:wand-change', { detail: { bef: btn.dataset.value } }));
        });
      });
      QA(wandBlock, '[data-rt3d-set="wandseite"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          QA(wandBlock, '[data-rt3d-set="wandseite"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
          root.dispatchEvent(new CustomEvent('rt3d:wandseite-change', { detail: { seite: btn.dataset.value } }));
        });
      });
    });
    /* Boden/Decke sind Rt's eigene [data-rt-set]-Buttons -- Rt's Klick-Handler laeuft zuerst
       (raumteiler-konfigurator.js laedt zuerst, siehe Sektions-Kommentar), aktualisiert Preis/
       Property/aria-pressed, dann dieser Root-Listener werten die neuen Randbedingungen aus. */
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-rt-set="boden"]')) enforceMontageConstraints(root, 'boden');
      else if (e.target.closest('[data-rt-set="decke"]')) enforceMontageConstraints(root, 'decke');
    });
  }

  /* Sehr kleine, lokale Preis-Formatierung -- derselbe Fallback-Ansatz wie Rt.money() in
     raumteiler-konfigurator.js (globales formatPriceAmount, sonst toLocaleString), keine
     Kopie von dessen Logik, nur derselbe zweizeilige Trick fuer denselben Zweck. */
  function money(cents, currency) {
    var f = window.formatPriceAmount;
    if (typeof f === 'function') { var r = f(cents, currency); if (r) return r; }
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: currency || 'EUR' });
  }

  function bindRegal(root) {
    var block = Q(root, '[data-rt3d-regal]');
    if (!block) return null;
    var options = Q(block, '[data-rt3d-regal-options]');
    var kCont = Q(block, '[data-rt3d-regal-k]');
    var posRange = Q(block, '[data-rt3d-regal-pos]');
    var nRange = Q(block, '[data-rt3d-regal-n]');
    var boardList = Q(block, '[data-rt3d-board-list]');
    var evenBtn = Q(block, '[data-rt3d-regal-even]');
    var currency = block.dataset.rt3dRegalCurrency || 'EUR';
    var products = {
      3: { variant: block.dataset.rt3dRegalK3Variant, price: +block.dataset.rt3dRegalK3Price || 0, available: block.dataset.rt3dRegalK3Available === 'true', title: block.dataset.rt3dRegalK3Title },
      4: { variant: block.dataset.rt3dRegalK4Variant, price: +block.dataset.rt3dRegalK4Price || 0, available: block.dataset.rt3dRegalK4Available === 'true', title: block.dataset.rt3dRegalK4Title }
    };
    var state = { aktiv: false, k: 4, n: nRange ? +nRange.value : 5 };

    function currentHeightMM() {
      var v = root._rt3dViewer;
      if (v && typeof v.getHeightMM === 'function') return v.getHeightMM();
      var h = Q(root, '[data-rt-hoehe]');
      var cm = h && h.value ? +h.value : null;
      if (cm && cm >= 180 && cm <= 300) return Math.round((cm - 0.5) * 10);
      return PROGRAMM.hoehe_standard;
    }

    /* Nur bestellbar, wenn fuer die gewaehlte Regal-Breite ein Produkt verknuepft UND
       dessen Variante verfuegbar ist -- sonst bleibt es wie zuvor reine Vorschau. */
    function activeProduct() { return products[state.k]; }
    function isOrderable() { var p = activeProduct(); return !!(p && p.variant && p.available); }

    function updatePriceUI() {
      var statusEl = Q(block, '[data-rt3d-regal-status]');
      var previewHint = Q(block, '[data-rt3d-regal-hint]');
      var orderHint = Q(block, '[data-rt3d-regal-order-hint]');
      var priceRow = Q(block, '[data-rt3d-regal-price-row]');
      var priceTxt = Q(block, '[data-rt3d-txt="regal-price"]');
      var summaryRow = Q(root, '[data-rt3d-row="regal-price"]');
      var summaryTxt = Q(root, '[data-rt3d-txt="regal-price-summary"]');
      var orderable = state.aktiv && isOrderable();

      if (statusEl) statusEl.hidden = orderable;
      if (previewHint) previewHint.hidden = orderable;
      if (orderHint) orderHint.hidden = !orderable;
      if (priceRow) priceRow.hidden = !orderable;
      if (summaryRow) summaryRow.hidden = !orderable;

      if (orderable) {
        var p = activeProduct();
        var total = p.price * state.n;
        var txt = state.n + ' × ' + money(p.price, currency) + ' = ' + money(total, currency);
        if (priceTxt) priceTxt.textContent = txt;
        if (summaryTxt) summaryTxt.textContent = txt + ' (' + (p.title || '') + ')';
      }
    }

    QA(block, '[data-rt3d-set="regal"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var an = btn.dataset.value === 'an';
        QA(block, '[data-rt3d-set="regal"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        if (options) options.hidden = !an;
        state.aktiv = an;
        updatePriceUI();
        root.dispatchEvent(new CustomEvent('rt3d:regal-toggle', { detail: { aktiv: an } }));
      });
    });

    QA(block, '[data-rt3d-regal-k-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        QA(block, '[data-rt3d-regal-k-btn]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        state.k = +btn.dataset.k;
        updatePriceUI();
        root.dispatchEvent(new CustomEvent('rt3d:regal-k-change', { detail: { k: +btn.dataset.k } }));
      });
    });

    if (posRange) posRange.addEventListener('input', function () {
      var mm = +posRange.value * PROGRAMM.profil.raster;
      QA(block, '[data-rt3d-txt="regal-pos"]').forEach(function (el) { el.textContent = mm + ' mm ab links'; });
      root.dispatchEvent(new CustomEvent('rt3d:regal-pos-change', { detail: { start: +posRange.value } }));
    });

    function renderBoardRows(heights) {
      if (!boardList) return;
      var hMM = currentHeightMM();
      var zMin = PROGRAMM.profil.leiste_h + PROGRAMM.regal.rand_leiste;
      var zMax = hMM - PROGRAMM.profil.leiste_h - PROGRAMM.regal.rand_leiste - PROGRAMM.regal.board_t;
      boardList.innerHTML = '';
      heights.forEach(function (z, i) {
        var lo = i === 0 ? zMin : heights[i - 1] + PROGRAMM.regal.rand_boden;
        var hi = i === heights.length - 1 ? zMax : heights[i + 1] - PROGRAMM.regal.rand_boden;
        var row = document.createElement('div');
        row.className = 'rt3d__board-row';
        row.innerHTML = '<span>Boden ' + (i + 1) + '</span>' +
          '<input type="range" class="rt-range" min="' + Math.round(lo) + '" max="' + Math.round(hi) + '" step="5" value="' + z + '">' +
          '<input type="number" class="rt-input" min="' + Math.round(lo) + '" max="' + Math.round(hi) + '" step="1" value="' + z + '">';
        boardList.appendChild(row);
        var range = row.querySelector('input[type=range]'), num = row.querySelector('input[type=number]');
        var onChange = function (v) { root.dispatchEvent(new CustomEvent('rt3d:board-change', { detail: { index: i, value: +v } })); };
        var onCommit = function () { root.dispatchEvent(new CustomEvent('rt3d:board-commit')); };
        range.addEventListener('input', function () { num.value = range.value; onChange(range.value); });
        range.addEventListener('change', onCommit);
        num.addEventListener('change', function () { range.value = num.value; onChange(num.value); onCommit(); });
      });
    }
    root.addEventListener('rt3d:board-rows-render', function (e) { renderBoardRows(e.detail.heights); });

    if (nRange) nRange.addEventListener('input', function () {
      QA(block, '[data-rt3d-txt="regal-n"]').forEach(function (el) { el.textContent = nRange.value; });
      state.n = +nRange.value;
      updatePriceUI();
      root.dispatchEvent(new CustomEvent('rt3d:regal-n-change', { detail: { n: +nRange.value } }));
    });
    if (evenBtn) evenBtn.addEventListener('click', function () {
      root.dispatchEvent(new CustomEvent('rt3d:regal-even'));
    });

    var kBtns = QA(block, '[data-rt3d-regal-k-btn]');
    root.addEventListener('rt3d:regal-sync', function (e) {
      var d = e.detail || {};
      if (d.kLabel) QA(block, '[data-rt3d-txt="regal-breite"]').forEach(function (el) { el.textContent = d.kLabel; });
      if (posRange && d.maxStart !== undefined) posRange.max = d.maxStart;
      if (nRange && d.maxN !== undefined) nRange.max = d.maxN;
    });

    updatePriceUI();
    return { getState: function () { return { aktiv: state.aktiv, k: state.k, n: state.n }; }, getProduct: activeProduct };
  }

  /* ------------------------------------------------------------------ *
   * Deckenart (Gerade / Dachschraege). Der Umschalter gilt bei allen Montagearten. Dachschraege = reine Konfigurator-Vorschau ohne
   * Fertigungsfreigabe (BLOCKER-RT-22) -> gleiche Konvention wie Wand/Regal: Badge "Nur Vorschau" +
   * Hinweistext. Bestellbar bleibt sie (Boden + Decke), die Messdaten gehen als Line-Item-Properties
   * mit: versteckte Felder mit form="<rt-form>" und name="properties[...]" -- Rt.properties()
   * sammelt alle solchen Formularfelder ein (nur nicht-disabled und ohne data-prop). Gleichnamige
   * Felder ueberschreiben Rt's eigene Werte: noetig, weil Rt die Raumhoehe nur in ganzen cm als
   * "kleinstes Mass" kennt.
   * ------------------------------------------------------------------ */
  function bindDeckenart(root, viewer) {
    var block = Q(root, '[data-rt3d-deckenart]');
    var mass = Q(root, '[data-rt3d-schraege]');
    if (!block || !viewer) return;
    var grid = mass ? Q(mass, '[data-rt3d-schraege-grid]') : null;
    var note = mass ? Q(mass, '[data-rt3d-schraege-note]') : null;
    var badge = Q(block, '[data-rt3d-schraege-badge]');
    var hint = Q(block, '[data-rt3d-schraege-hint]');
    var label = Q(block, '[data-rt3d-txt="deckenart-label"]');
    var gridKey = '';

    function prop(name) { return Q(root, '[data-rt3d-prop="' + name + '"]'); }
    function setProp(name, value) {
      var el = prop(name);
      if (!el) return;
      el.value = value == null ? '' : value;
      el.disabled = value == null;
    }
    var POS_NAME = { 3: ['Links', 'Mitte', 'Rechts'], 4: ['Links', 'Mitte links', 'Mitte rechts', 'Rechts'] };

    function renderGrid(info) {
      if (!grid) return;
      var key = info.n + ':' + info.breite;
      if (key === gridKey) return;
      gridKey = key;
      grid.style.setProperty('--rt3d-cols', info.n);
      grid.innerHTML = '';
      for (var i = 0; i < info.n; i++) {
        var lab = document.createElement('label');
        lab.className = 'rt3d__schraege-field';
        var t = document.createElement('span');
        t.textContent = POS_NAME[info.n][i] + ' · ' + info.positionen[i] + ' mm';
        var inp = document.createElement('input');
        inp.type = 'number'; inp.className = 'rt-input'; inp.inputMode = 'numeric';
        inp.min = SCHRAEGE_MIN; inp.max = SCHRAEGE_MAX; inp.step = 1; inp.placeholder = 'mm';
        inp.setAttribute('data-rt3d-schraege-punkt', String(i));
        inp.setAttribute('aria-label', 'Raumhöhe ' + POS_NAME[info.n][i] + ', ' + info.positionen[i] + ' mm von links, in Millimetern');
        if (typeof info.punkte[i] === 'number') inp.value = info.punkte[i];
        lab.appendChild(t); lab.appendChild(inp);
        grid.appendChild(lab);
      }
    }

    function render(info) {
      block.hidden = !info.moeglich;
      QA(block, '[data-rt3d-set="deckenart"]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.value === (info.aktiv ? 'schraege' : 'gerade')));
      });
      if (label) label.textContent = info.aktiv ? 'Dachschräge' : 'Gerade';
      if (badge) badge.hidden = !info.aktiv;
      if (hint) hint.hidden = !info.aktiv;
      if (mass) mass.hidden = !info.aktiv;
      /* Rt's Raumhoehe-Feld und der Montage-Check beschreiben eine GERADE Decke -> bei Schraege aus */
      QA(root, '.rt-block--hoehe').forEach(function (el) { el.hidden = info.aktiv; });
      QA(root, '[data-rt-check-panel]').forEach(function (el) { el.hidden = info.aktiv; });

      if (info.aktiv) {
        renderGrid(info);
        if (note) {
          var rest = info.gueltig
            ? '<b>Durchgehende Schräge, ' + de1(info.winkel) + '°.</b> Jede Lamelle folgt der Ausgleichsgeraden durch Ihre Messpunkte. Raumhöhe in der Mitte ≈ ' + info.mitte + ' mm, Bauhöhe ' + (info.mitte - 5) + ' mm (5 mm Einbauluft).'
            : 'Bitte alle ' + info.n + ' Messpunkte eintragen (' + SCHRAEGE_MIN + '–' + SCHRAEGE_MAX + ' mm). Erst dann ist die Konfiguration vollständig.';
          if (info.gueltig && (info.mitte < 1800 || info.mitte > 3000)) rest += ' Online bestellbar ist eine Raumhöhe in der Mitte von 180 bis 300 cm – darunter bitte kurz anfragen.';
          note.innerHTML = rest;
        }
      } else {
        gridKey = '';
      }

      /* Bestell-Properties: Messdaten fuer die Fertigung. Nur bei aktiver Schraege, sonst disabled
         (Rt ignoriert disabled-Felder) -> bei gerader Decke aendert sich die Bestellung nicht. */
      var on = info.aktiv;
      var richtung = info.winkel > 0 ? 'Decke steigt nach rechts' : (info.winkel < 0 ? 'Decke steigt nach links' : 'waagerecht');
      var punkte = info.punkte.map(function (v, i) {
        return POS_NAME[info.n][i] + ' (' + info.positionen[i] + ' mm): ' + (typeof v === 'number' ? v : 'fehlt');
      }).join(' · ');
      setProp('deckenart', on ? 'Dachschräge (durchgehend)' : null);
      setProp('messpunkte', on ? punkte + ' – Raumhöhe in mm, von links' : null);
      setProp('winkel', on ? de1(Math.abs(info.winkel)) + '° (' + richtung + ', von vorn gesehen)' : null);
      setProp('mitte', on ? info.mitte + ' mm' : null);
      setProp('hinweis', on ? 'Kundenplanung, Machbarkeit (Winkelschnitt, obere Leiste) vor Fertigung durch Werkstatt zu prüfen' +
        (info.art !== 'boden-decke' ? '. Im Konfigurator gewählte Montageart: ' + info.artName + ' (Vorschau)' : '') : null);
      setProp('raumhoehe', on && info.kleinster != null ? de1(info.kleinster / 10) + ' cm (Dachschräge: kleinster Messpunkt)' : null);
      setProp('bauhoehe', on ? de1((info.mitte - 5) / 10) + ' cm (Dachschräge: Mitte)' : null);
      setProp('check', on ? 'nicht anwendbar (Dachschräge)' : null);
    }

    QA(block, '[data-rt3d-set="deckenart"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.dispatchEvent(new CustomEvent('rt3d:deckenart-change', { detail: { deckenart: btn.dataset.value } }));
      });
    });
    if (grid) grid.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-rt3d-schraege-punkt]');
      if (!inp) return;
      var raw = inp.value.trim(), v = raw === '' ? null : Math.round(+raw);
      if (v !== null) {
        if (isNaN(v)) v = null; else { v = Math.max(SCHRAEGE_MIN, Math.min(SCHRAEGE_MAX, v)); inp.value = v; }
      }
      root.dispatchEvent(new CustomEvent('rt3d:schraege-change', { detail: { index: +inp.getAttribute('data-rt3d-schraege-punkt'), value: v } }));
    });
    root.addEventListener('rt3d:decken-sync', function (e) { render(e.detail); });
    viewer.rebuild(); /* der erste rebuild() lief vor dieser Bindung -> Zustand jetzt einmal einspielen */
  }

  /* ------------------------------------------------------------------ *
   * Tab-Assistent (Montage/Abmessungen/Oberflaeche/Regal/Uebersicht) --
   * analog zu tabZeigen() in konfigurator.html, aber pro Section-Root
   * skaliert statt auf ein einzelnes Dokument. Gruppiert nur die
   * bestehenden Bloecke optisch um, keine eigene Zustandslogik: Werte und
   * Bindungen der einzelnen Felder (Range/Radios/Buttons) bleiben unveraendert,
   * nur ihre Sichtbarkeit haengt jetzt am aktiven Tab.
   * ------------------------------------------------------------------ */
  function bindTabs(root) {
    var tabbar = Q(root, '[data-rt3d-tabbar]');
    if (!tabbar) return;
    var tabbtns = QA(root, '[data-rt3d-tabbtn]');
    var panels = QA(root, '[data-rt3d-tabpanel]');
    var backBtn = Q(root, '[data-rt3d-tabback]');
    var nextBtn = Q(root, '[data-rt3d-tabnext]');
    var panelHost = Q(root, '.rt3d__panel');

    function keys() { return tabbtns.map(function (b) { return b.dataset.rt3dTabbtn; }); }
    function panelFor(key) { return panels.filter(function (p) { return p.dataset.rt3dTabpanel === key; })[0]; }
    function currentIndex() {
      var ks = keys();
      var activeBtn = tabbtns.filter(function (b) { return b.getAttribute('aria-selected') === 'true'; })[0];
      var i = activeBtn ? ks.indexOf(activeBtn.dataset.rt3dTabbtn) : 0;
      return i < 0 ? 0 : i;
    }

    function show(key) {
      tabbtns.forEach(function (b) { b.setAttribute('aria-selected', String(b.dataset.rt3dTabbtn === key)); });
      panels.forEach(function (p) { p.hidden = p.dataset.rt3dTabpanel !== key; });
      var ks = keys(), i = ks.indexOf(key);
      if (backBtn) backBtn.hidden = i <= 0;
      if (nextBtn) nextBtn.hidden = i >= ks.length - 1;
      if (panelHost) panelHost.scrollTop = 0;
    }

    tabbtns.forEach(function (btn) {
      btn.addEventListener('click', function () { show(btn.dataset.rt3dTabbtn); });
    });
    if (backBtn) backBtn.addEventListener('click', function () {
      var ks = keys(), i = currentIndex();
      if (i > 0) show(ks[i - 1]);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      var ks = keys(), i = currentIndex();
      if (i < ks.length - 1) show(ks[i + 1]);
    });

    /* Aktiven Tab initial korrekt spiegeln (Liquid rendert bereits ein Tabpanel
       ohne [hidden] -- z. B. wenn der Merchant im Theme Editor ein Feld daraus
       ausgewaehlt hat), inkl. Zurueck/Weiter-Sichtbarkeit. */
    var initial = panels.filter(function (p) { return !p.hidden; })[0];
    show(initial ? initial.dataset.rt3dTabpanel : keys()[0]);
  }

  /* ------------------------------------------------------------------ *
   * Zentrale Verdrahtung: der Viewer haelt den einzigen echten M/REG-Zustand
   * (er baut ja das Modell); die Bloecke senden Custom Events, der Viewer
   * hoert sie und uebernimmt den Wert in sein eigenes M/REG bevor er neu baut.
   * ------------------------------------------------------------------ */
  function wireEvents(root, viewer) {
    if (!viewer) return;
    root.addEventListener('rt3d:art-change', function (e) { viewer._Mset('art', e.detail.art); viewer.rebuild(); });
    root.addEventListener('rt3d:wand-change', function (e) { viewer._Mset('bef.wand', e.detail.bef); viewer.rebuild(); });
    root.addEventListener('rt3d:wandseite-change', function (e) { viewer._Mset('wandSeite', e.detail.seite); viewer.rebuild(); });
    root.addEventListener('rt3d:deckenart-change', function (e) { viewer._Mset('deckenart', e.detail.deckenart); viewer.rebuild(); });
    root.addEventListener('rt3d:schraege-change', function (e) { viewer._SCHRset(e.detail.index, e.detail.value); viewer.rebuild(); });
    root.addEventListener('rt3d:regal-toggle', function (e) { viewer._REGset('aktiv', e.detail.aktiv); viewer.rebuild(); });
    root.addEventListener('rt3d:regal-k-change', function (e) { viewer._REGset('k', e.detail.k); viewer.rebuild(); });
    root.addEventListener('rt3d:regal-pos-change', function (e) { viewer._REGset('start', e.detail.start); viewer.rebuild(); });
    root.addEventListener('rt3d:regal-n-change', function (e) { viewer._REGset('n', e.detail.n); viewer.rebuild(); });
    root.addEventListener('rt3d:regal-even', function () { viewer._REGeven(); viewer.rebuild(); });
    root.addEventListener('rt3d:board-change', function (e) { viewer._boardChange(e.detail.index, e.detail.value); viewer.rebuild(); });
    root.addEventListener('rt3d:board-commit', function () { viewer._boardCommit(); });
  }

  /* ------------------------------------------------------------------ *
   * Preis IM "In den Warenkorb"-Button (Haupt- und Sticky-CTA) inkl.
   * Regal-Add-on. Rt schreibt [data-rt-cta-text] bei JEDER Aenderung neu
   * (raumteiler-konfigurator.js render(): label = ctaLabel + ' · ' + preis,
   * synchron innerhalb desselben input/click-Handlers). raumteiler-
   * konfigurator.js wird als ERSTES Script geladen (siehe Sektions-
   * Kommentar im .liquid), raumteiler-konfigurator-3d.js danach -- Event-
   * Listener auf demselben Root feuern in Registrierungsreihenfolge, Rt's
   * render() ist also in jedem Klick/Input-Handler bereits fertig, bevor
   * dieser Listener hier laeuft. Deshalb reicht ein simples Ueberschreiben
   * NACH Rt, ohne Race: bei aktivem, bestellbarem Regal ersetzt es Rt's
   * Text durch denselben Aufbau (Label · Gesamtpreis), sonst laesst es
   * Rt's eigenen (korrekten) Text unangetastet. */
  function bindTotalPrice(root, regal) {
    if (!regal) return;
    var ctaTexts = QA(root, '[data-rt-cta-text]');
    if (!ctaTexts.length) return;
    var productData = null;
    try { var pj = Q(root, '#rt-product-json'); if (pj) productData = JSON.parse(pj.textContent); } catch (e) { /* noop */ }
    var optOber = root.dataset.optOber, optBreite = root.dataset.optBreite;
    var ctaLabel = root.dataset.ctaLabel || '';

    function currentVariantPrice() {
      if (!productData || !productData.variants) return 0;
      var oberEl = Q(root, 'input[name="rt-oberflaeche"]:checked');
      var selEl = Q(root, '[data-rt-select]');
      var ober = oberEl ? oberEl.value : null;
      var breite = selEl ? selEl.value : null;
      var oKey = 'option' + optOber, bKey = 'option' + optBreite;
      var match = productData.variants.filter(function (v) {
        return (!ober || v[oKey] === ober) && (!breite || String(v[bKey]) === String(breite));
      })[0];
      return match ? match.price : 0;
    }

    function update() {
      var state = regal.getState();
      var product = regal.getProduct();
      var orderable = state.aktiv && product && product.variant && product.available && state.n;
      if (!orderable) return; /* Rt's eigener Text (nur Raumteiler-Preis) bleibt stehen */
      var regalBlock = Q(root, '[data-rt3d-regal]');
      var currency = regalBlock ? regalBlock.dataset.rt3dRegalCurrency : null;
      var total = currentVariantPrice() + product.price * state.n;
      var label = ctaLabel + ' · ' + money(total, currency);
      ctaTexts.forEach(function (el) { el.textContent = label; });
    }

    ['input', 'change', 'click'].forEach(function (evt) { root.addEventListener(evt, update); });
    root.addEventListener('variant:change', update);
    update();
  }

  /* ------------------------------------------------------------------ *
   * Regal als Bestell-Add-on: NUR wenn ein Produkt fuer die gewaehlte
   * Regal-Breite verknuepft ist (siehe bindRegal/isOrderable). Fuegt die
   * Regalbretter NICHT ueber Rt's eigenes Formular hinzu (das kennt nur
   * eine Variante), sondern als zweiten, eigenstaendigen /cart/add.js-
   * Aufruf, ausgeloest ueber Shopifys eigenes PubSub (assets/pubsub.js,
   * global geladen in layout/theme.liquid), NACHDEM Rt den Raumteiler
   * selbst erfolgreich hinzugefuegt hat (Rt feuert cartUpdate erst nach
   * einer erfolgreichen Antwort, nie bei einem Fehler). Kein Eingriff in
   * assets/raumteiler-konfigurator.js noetig. */
  function bindRegalCartAddon(root, regal, viewer) {
    if (!regal || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    var productData = null;
    try { var pj = Q(root, '#rt-product-json'); if (pj) productData = JSON.parse(pj.textContent); } catch (e) { /* noop */ }
    var ownVariantIds = productData && productData.variants ? productData.variants.map(function (v) { return String(v.id); }) : [];

    function cartSections() {
      var sec = [{ id: 'Cart-Icon-Bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
      var dr = Q(document, '#Cart-Drawer');
      if (dr && !dr.hasAttribute('data-status-silence')) sec.push({ id: 'Cart-Drawer', section: dr.dataset.section, selector: '#Cart-Drawer-Details' });
      return sec;
    }

    /* Kunden-Planungsmasse als sichtbare Line-Item-Properties (wie Rt's eigene
       properties() in raumteiler-konfigurator.js): Werkstatt braucht Position,
       Regal-Breite, Boeden-Anzahl und Boeden-Hoehen fuer die Fertigung. Es sind
       Kundenangaben, keine geprueften Werkstatt-Masse (BLOCKER-RT-20/21: noch
       nicht FABRICATION_READY) -- daher als Planungshinweis gekennzeichnet. */
    function regalProperties() {
      var reg = viewer && typeof viewer.getRegalState === 'function' ? viewer.getRegalState() : null;
      if (!reg) return {};
      return {
        'Regal – Position (ab links)': reg.startMM + ' mm',
        'Regal – Breite': reg.kAussenMM + ' mm',
        'Regal – Böden': String(reg.n),
        'Regal – Bodenhöhen (ab Boden)': reg.heights.join(', ') + ' mm',
        'Regal – Hinweis': 'Kundenplanung, vor Fertigung durch Werkstatt zu prüfen'
      };
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.productVariantId && ownVariantIds.length && ownVariantIds.indexOf(String(event.productVariantId)) === -1) return;
      var state = regal.getState();
      var product = regal.getProduct();
      if (!state.aktiv || !product || !product.variant || !product.available || !state.n) return;

      var sec = cartSections();
      fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: product.variant,
          quantity: state.n,
          properties: regalProperties(),
          sections: sec.map(function (s) { return s.section; }).join(),
          sections_url: location.pathname
        })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok || r.data.status) {
            var err = Q(root, '[data-rt-error]');
            if (err) { err.textContent = (r.data && (r.data.description || r.data.message)) || 'Regalbretter konnten nicht zum Warenkorb hinzugefügt werden.'; err.hidden = false; }
            return;
          }
          if (typeof SectionDynamicUpdate !== 'undefined' && r.data.sections) SectionDynamicUpdate.updateSections(sec, r.data.sections);
        })
        .catch(function () {
          var err = Q(root, '[data-rt-error]');
          if (err) { err.textContent = 'Regalbretter konnten nicht zum Warenkorb hinzugefügt werden.'; err.hidden = false; }
        });
    });
  }

  function boot() {
    QA(document, '[data-rt-konfigurator]:not([data-rt3d-ready])').forEach(function (root) {
      var viewerBlock = Q(root, '[data-rt3d-root]');
      if (!viewerBlock) return;
      root.setAttribute('data-rt3d-ready', '1');
      var viewer = createViewer(root, viewerBlock);
      root._rt3dViewer = viewer;
      bindMontageart(root);
      bindBefestigungWand(root);
      var regal = bindRegal(root);
      bindRegalCartAddon(root, regal, viewer);
      bindTotalPrice(root, regal);
      bindTabs(root);
      wireEvents(root, viewer);
      bindDeckenart(root, viewer);
    });
  }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
